export const crmBasePath = 'crm';
export const crmPrescripteurDetail = '/crm/prescripteur';
